"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const SelectHolder = _styledComponents.default.div.withConfig({
  displayName: "Select__SelectHolder",
  componentId: "design-system__sc-16vgykt-0"
})(["border:1px solid ", ";border-radius:", ";background:", ";position:relative;&::after{content:'';display:block;width:40px;height:100%;position:absolute;top:0;right:0;z-index:1;border-left:1px solid ", ";}svg{position:absolute;top:50%;transform:translateY(-50%);right:12px;width:16px;height:16px;fill:", ";}select{appearance:none;border:0;margin:0;padding:0;background:transparent;display:block;width:100%;font-size:", ";line-height:20px;padding:9px 46px 9px ", ";box-sizing:border-box;color:", ";font-family:", ";position:relative;z-index:2;&:focus{outline:0;}}"], _BaseTheme.default.colors.gray, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.white, _BaseTheme.default.colors.gray, _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.size.normal, _BaseTheme.default.distance.normal, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.content);

const Select = _ref => {
  let {
    children,
    value,
    name,
    id,
    disabled,
    placeholder,
    size,
    error,
    onBlur,
    onChange,
    onClick,
    onFocus
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "value", "name", "id", "disabled", "placeholder", "size", "error", "onBlur", "onChange", "onClick", "onFocus"]);

  return /*#__PURE__*/_react.default.createElement(SelectHolder, null, /*#__PURE__*/_react.default.createElement("select", _extends({
    value: typeof value === 'undefined' && placeholder ? '' : value,
    name: name,
    id: id,
    disabled: disabled,
    size: size,
    error: error.toString(),
    onBlur: onBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: onFocus
  }, props), !!placeholder && /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), children), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "arrow"
  }));
};

Select.propTypes = {
  value: _propTypes.default.string,
  children: _propTypes.default.node,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  size: _propTypes.default.string,
  error: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func
};
Select.defaultProps = {
  children: undefined,
  value: undefined,
  placeholder: undefined,
  name: '',
  id: '',
  disabled: false,
  size: '0',
  error: false,
  onBlur: undefined,
  onChange: undefined,
  onClick: undefined,
  onFocus: undefined
};
var _default = Select;
exports.default = _default;